var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"playlist"}}),_c('button',{on:{"click":_vm.pause}},[_vm._v("pause")]),_c('button',{on:{"click":_vm.play}},[_vm._v("play")])])}
var staticRenderFns = []

export { render, staticRenderFns }